import React from 'react';
import { Text, Flex, Icon, useTheme, Box } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { isRiskAnalysisFlow } from '../../../../common/src/utils/globalVariables';
import useAuth from '../../../../app/src/features/authentication/hooks/useAuth';
import { sanitize } from 'dompurify';

const IntroInfoText: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { distribution } = useAuth();
  const { colors } = useTheme();
  const { t } = useTranslation();
  const privacyUrl = distribution.privacy_page_url;

  return (
    <Flex mt="6">
      <Box flexShrink={0} mr="2">
        <Icon name="IconInfoFilled" color={colors.gray[300]} />
      </Box>
      <Text
        color="gray.300"
        textStyle="smallBody"
        dangerouslySetInnerHTML={{
          __html: isRiskAnalysisFlow()
            ? sanitize(
                t('ADVISORY-CONVERSATION_INTRO_INFO_RISK-ANALYSIS', {
                  privacyUrl,
                }),
                { ADD_ATTR: ['target'] },
              )
            : t(
                'In the context of requesting or preparing an offer, we need your personal data The data you enter in the screens provided by us, will then be kept, so that we can guide you as best as possible to finding the insurance that suits you',
              ),
        }}
      />
    </Flex>
  );
};

export default IntroInfoText;
